export default function SvgBookOrangeIcon() {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_9507_245321)">
        <rect
          x="12"
          y="0.549805"
          width="32"
          height="32"
          rx="8"
          fill="#FF692E"
        />
        <path
          d="M27.9997 22.5498L27.933 22.4498C27.4699 21.7551 27.2383 21.4078 26.9324 21.1563C26.6616 20.9338 26.3495 20.7667 26.0141 20.6649C25.6352 20.5498 25.2177 20.5498 24.3829 20.5498H23.4663C22.7196 20.5498 22.3462 20.5498 22.061 20.4045C21.8101 20.2766 21.6062 20.0727 21.4783 19.8218C21.333 19.5366 21.333 19.1632 21.333 18.4165V12.6831C21.333 11.9364 21.333 11.563 21.4783 11.2778C21.6062 11.0269 21.8101 10.823 22.061 10.6951C22.3462 10.5498 22.7196 10.5498 23.4663 10.5498H23.733C25.2265 10.5498 25.9732 10.5498 26.5436 10.8405C27.0454 11.0961 27.4534 11.5041 27.709 12.0058C27.9997 12.5763 27.9997 13.323 27.9997 14.8165M27.9997 22.5498V14.8165M27.9997 22.5498L28.0664 22.4498C28.5295 21.7551 28.761 21.4078 29.0669 21.1563C29.3378 20.9338 29.6498 20.7667 29.9853 20.6649C30.3642 20.5498 30.7816 20.5498 31.6165 20.5498H32.533C33.2797 20.5498 33.6531 20.5498 33.9383 20.4045C34.1892 20.2766 34.3932 20.0727 34.521 19.8218C34.6663 19.5366 34.6663 19.1632 34.6663 18.4165V12.6831C34.6663 11.9364 34.6663 11.563 34.521 11.2778C34.3932 11.0269 34.1892 10.823 33.9383 10.6951C33.6531 10.5498 33.2797 10.5498 32.533 10.5498H32.2663C30.7729 10.5498 30.0261 10.5498 29.4557 10.8405C28.9539 11.0961 28.546 11.5041 28.2903 12.0058C27.9997 12.5763 27.9997 13.323 27.9997 14.8165"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_9507_245321"
          x="0"
          y="0.549805"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="12"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9507_245321"
          />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.180392 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9507_245321"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_9507_245321"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
